import { render, staticRenderFns } from "./OrganizationSingleSelector.vue?vue&type=template&id=cf52b24c&scoped=true&"
import script from "./OrganizationSingleSelector.vue?vue&type=script&lang=js&"
export * from "./OrganizationSingleSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf52b24c",
  null
  
)

export default component.exports